import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: "#ffb020",
        secondary: "#5ee9d5",
        accent: "#ffb020",
        background: "#08090a",
      },
    },
  },
  icons: {
    iconfont: "mdi",
  },
});
